/* eslint-disable no-unused-vars */
const abortCrtlReady = typeof new AbortController() == "object";
const utils_vars = {
	head: document.head,
	body: document.body,
	header: document.getElementById("main-header"),
	nav: document.getElementById("main-nav"),
	footer: document.getElementById("main-footer"),
	overlay: document.getElementById("overlay"),
	topBtn: document.getElementById("back-to-top"),
	breakpoint: {
		xs: 0,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
		xxl: 1400,
	},
	docWidth: window.innerWidth,
	docHeight: window.innerHeight,
	observerReady: "IntersectionObserver" in window,
	resizerReady: "ResizeObserver" in window,
	scrollPaused: false,
	screen: {
		mobile: false,
		desk: false,
		resized: false,
	},
	generalPerfBoost: false,
	device: {
		switchPerformanceMode: function () {
			if (typeof window.OffscreenCanvas === "function") {
				const canvas = new OffscreenCanvas(1, 1);
				let gl,
					attributes = {
						alpha: false,
						stencil: false,
						antialias: false,
						depth: false,
						failIfMajorPerformanceCaveat: true,
						powerPreference: "high-performance", //TODO vedere impatto
					};

				try {
					gl =
						canvas.getContext("webgl", attributes) ||
						canvas.getContext("experimental-webgl", attributes);
				} catch (e) {
					console.error(e);
				}
			}
		},
	},
	eventsController: {
		// https://www.macarthur.me/posts/options-for-removing-event-listeners
		mobile: {
			controller: abortCrtlReady ? new AbortController() : { signal: null },
		},
		desk: {
			controller: abortCrtlReady ? new AbortController() : { signal: null },
		},
	},

	detectScreen: function () {
		utils_vars.screen.mobile = utils_vars.docWidth <= utils_vars.breakpoint.lg;
		utils_vars.screen.desk = utils_vars.docWidth > utils_vars.breakpoint.lg;
	},

	pauseScroll: function () {
		if (!utils_vars.scrollPaused) {
			utils_vars.body.style.overflow = "hidden";
			utils_vars.scrollPaused = true;
		}
	},

	resumeScroll: function () {
		if (utils_vars.scrollPaused) {
			utils_vars.body.style.overflow = "";
			utils_vars.scrollPaused = false;
		}
	},

	initResizeObserver: function () {
		if (utils_vars.resizerReady) {
			const resizeObserver = new ResizeObserver(function (entries) {
				for (const entry of entries) {
					if (entry.contentBoxSize) {
						const width = entry.contentBoxSize[0].inlineSize;
						utils_vars.docWidth = width;
						if (width <= utils_vars.breakpoint.lg) {
							if (!utils_vars.screen.mobile) {
								if (abortCrtlReady) {
									utils_vars.eventsController.desk.controller.abort();
									utils_vars.eventsController.desk.controller =
										new AbortController();
									utils_vars.screen.desk = false;
									utils_vars.screen.mobile = true;
									utils_vars.screen.resized = true;
									window.restoreEvents();
								} else {
									location.reload();
								}
							}
						} else {
							if (!utils_vars.screen.desk) {
								if (abortCrtlReady) {
									utils_vars.eventsController.mobile.controller.abort();
									utils_vars.eventsController.mobile.controller =
										new AbortController();
									utils_vars.screen.mobile = false;
									utils_vars.screen.desk = true;
									utils_vars.screen.resized = true;
									window.restoreEvents();
								} else {
									location.reload();
								}
							}
						}
					}
				}
			});
			resizeObserver.observe(utils_vars.header);
		} else {
			window.addEventListener(
				"resize",
				utils_vars.throttle(function () {
					let width = window.innerWidth;
					utils_vars.docWidth = width;
					if (width <= utils_vars.breakpoint.lg) {
						if (!utils_vars.screen.mobile) {
							location.reload();
						}
					} else {
						if (!utils_vars.screen.desk) {
							location.reload();
						}
					}
				}, 20)
			);
		}
	},

	// funzione di caricamento ajax
	ajaxLoad(url, method, contentType, type, params, callback) {
		// TODO change with fetch api
		let oReq = new XMLHttpRequest();
		oReq.onload = function (e) {
			let response = e.target.response;
			if (callback) {
				callback(response);
			}
		};
		oReq.open(method, url, true);
		if (type) {
			oReq.responseType = type;
		}
		if (contentType) {
			oReq.setRequestHeader("Content-type", contentType);
		}
		if (params) {
			oReq.send(params);
		} else {
			oReq.send();
		}
	},

	// DOM ready
	domReady: (callback) => {
		document.readyState === "interactive" || document.readyState === "complete"
			? callback()
			: document.addEventListener("DOMContentLoaded", callback);
	},

	throttle: function (callback, limit) {
		let tick = false;
		return function () {
			if (!tick) {
				callback.call();
				tick = true;
				setTimeout(function () {
					tick = false;
				}, limit);
			}
		};
	},

	// loop helper
	forEach(array, callback, scope) {
		for (let i = 0; i < array.length; i++) {
			callback.call(scope, i, array[i]);
		}
	},

	isImageLoaded(img, callback) {
		if (img.complete && img.naturalHeight !== 0) {
			callback(img);
		} else {
			img.onload = function () {
				callback(img);
			};
		}
	},

	scrollTop: function (elem) {
		elem.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	},

	scrollIntoView: function (elem) {
		elem.scrollIntoView({
			behavior: "smooth",
		});
	},

	setAnchorScroll: function () {
		const anchors = document.querySelectorAll('a[href^="#"]');
		if (anchors.length > 0) {
			utils_vars.forEach(anchors, function (index, anchor) {
				anchor.addEventListener("click", function (e) {
					e.preventDefault();
					let destination = document.querySelector(anchor.hash);
					utils_vars.scrollIntoView(destination);
				});
			});
		}
	},

	injectAtkConsole() {
		if (utils_vars.screen.desk) {
			console.log(
				"%c\n\n\nJust one more website by %cATK+LAB %c- https://www.atklab.com %c👌🏻 %c\n\nFollow us on: \n\nhttps://www.facebook.com/atklab%c\n\nhttps://www.linkedin.com/company/atk-lab %c\n\ninfo@atklab.com %c\n\nGet in touch! %c👋🏻\n\n\n",
				"color:#595959;font-size:12px;",
				"font-weight: bold;font-size: 12px;",
				"color:#999;",
				"font-size:20px;",
				"color:#595959;",
				"",
				"",
				"color:#595959;font-size: 12px;",
				"font-size:20px;"
			);
		}
	},

	loadScript(link, async, callback) {
		let script = document.createElement("script");
		script.src = link;
		if (async) {
			script.setAttribute("async", "");
		}
		if (callback) {
			script.addEventListener("load", callback);
		}
		document.body.appendChild(script);
	},
	setGlobalVars: function (vars) {
		window.scrollTop = utils_vars.scrollTop;
		vars();
	},
};

export default utils_vars;
